export { SanitizedHtml, type SanitizedHtmlProps } from './sanitized-html'
